import { getApplicationList } from "@/api/apiclient/application";
import type { applicationType } from "@/types/application";
import { defineStore } from "pinia";

export const useContext = defineStore("context", {
  state: () => {
    return {
      list: [] as Array<applicationType>,
      availableApplications: [] as Array<applicationType>,
    };
  },
  actions: {
    async loadApplicationList() {
      try {
        const res = (await getApplicationList()).data;
        if (res && res.length > 0) {
          this.list = res;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  getters: {
    getNameFromId(state) {
      return (id: number | null): string | number | null => {
        return state.list.find((i) => i.id == id)?.name ?? id;
      };
    },
    getInfoFromId(state) {
      return (id: number | null): applicationType | null => {
        return state.list.find((i) => i.id == id) ?? null;
      };
    },
    // controllo hardcoded per mostrare il campo partita IVA solo per specifiche applicazioni
    showCompanyVat(state) {
      return (applicationId?: number | null): boolean => {
        if (applicationId == null) return false;
        const application = state.list.find((i) => i.id === applicationId);
        if (!application) return false;
        return ['AGORA', 'HDENTERPRISE', 'HAWAY', 'FSTOCK'].includes(application.code);
      };
    },
  },
});
